
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import Button from '@/components/atoms/button';
import Link from '@/components/atoms/link';
import Typography from '@/components/atoms/typography';
import useFormat from '@/hooks/useFormat';
import { Currency } from '@/types/currency';
import { ChevronLeftIcon ,ChevronRightIcon } from '@heroicons/react/24/solid';

const CartHeader = ({ total, onCheckout, lineItems }: { total: any, onCheckout: any, lineItems: any }) => {
    const { translate } = useTranslation();
    const { formatCurrency } = useFormat();

    return (
        <div className=" flex justify-between w-full p-4 flex-wrap lg:grid lg:grid-cols-[1fr_1fr_160px] lg:gap-4 lg:px-0">
            <div className='flex flex-col gap-[12px] w-1/2'>
                <Typography className='text-[32px] font-medium leading-[38.73px] '>Cart</Typography>
                <div className='flex gap-2 items-center'>
                    <Link className='font-light text-[17px] leading-[20.57px]' chevron={true} link={"/"}>
                        Home
                    </Link>
                    <ChevronRightIcon width={16} />
                    <Link className='font-semibold text-[17px] leading-[20.57px]' link={"/cart"}>
                        Cart
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CartHeader;
